module.exports = __webpack_public_path__ + "static/4i-117e995c97eab30fb92843616018d1f1.woff2";